import { Exclude, Expose } from 'class-transformer';
import { Sex } from 'shared/sex.enum';

/**
 * A validated animal from an uploaded spreadsheet.
 */
@Exclude()
export class CatalogueAnimal {
  @Expose()
  animalId: string;

  @Expose({ name: 'displayedId' })
  displayId: string;

  @Expose()
  price: number;

  @Expose()
  sex: Sex;

  @Expose()
  lot: number;

  @Expose()
  doses: string;
}
